import { AuthContext } from "./index";
import { ChildrenType } from "../../interfaceTypes";
import { useMemo, useReducer, FC } from "react";
import {
  Auth_Action,
  authReducer,
  authStoreDefaultValue,
} from "../../reducers/AuthContextReducer";

/**
 * Auth context provider to share  authentication related states
 *
 * @component
 * @prop {JSX.Element} children - components that need access to auth related states
 * @returns {JSX.Element } The JSX element
 */
export const AuthProvider: FC<ChildrenType> = ({ children }) => {
  const [authStore, dispatchAuthAction] = useReducer(
    authReducer,
    authStoreDefaultValue
  );

  const store = useMemo(() => {
    return { ...authStore, dispatchAuthAction };
  }, [authStore]);

  const setIsLoggedIn = (isLoggedIn: boolean) => {
    dispatchAuthAction({ type: Auth_Action.SET_IS_LOGGED_IN, isLoggedIn });
  };

  const setLoggedInUser = <T,>(loggedInUser: T) => {
    dispatchAuthAction({ type: Auth_Action.SET_LOGGED_IN_USER, loggedInUser });
  };

  const setUserLoader = (userLoader: boolean) => {
    dispatchAuthAction({ type: Auth_Action.SET_USER_LOADER, userLoader });
  };

  return (
    <AuthContext.Provider
      value={{ ...store, setIsLoggedIn, setLoggedInUser, setUserLoader }}
    >
      {children}
    </AuthContext.Provider>
  );
};
